import DentistCoference from './components/DentistConference/DentistConference'
import { DentistConferenceContextProvider } from "./components/DentistConference/dentistContext/DentistConferenceContext";
import { Routes, Route } from "react-router-dom";
import SignupForm from "./components/SignupForm/appLoginForm";
import CircularMenuContainer from "./components/CircularMenu/CircularMenuContainer.js";
import { QueryClient, QueryClientProvider} from 'react-query'

const App = () => {
  const queryClient = new QueryClient()
  return (
    <>
      <Routes>
        <Route exact path="/" element={<SignupForm />} />
        <Route path="/admin" element={<CircularMenuContainer />} />
        <Route
          path="/dentistconference"
          element={
            <QueryClientProvider client={queryClient}>
              <DentistConferenceContextProvider>
                 <DentistCoference/>
              </DentistConferenceContextProvider>
            </QueryClientProvider>

          }
        />
        {/* <Route
          path="/dentistconference"
          element={
            <QueryClientProvider client={queryClient}>
              <ItMaintenenceContextProvider>
                 <ItMaintenence/>
              </ItMaintenenceContextProvider>
            </QueryClientProvider>
          }
        /> */}
        <Route path="*" element={<SignupForm />} />
      </Routes>
    </>
  );
};
export default App;
